/* eslint-disable brace-style */
/**
 * Crash Page Component
 * This component has Container and Presentational attribute all-in-one
 */

import React, {useState} from 'react';
import { Offline, Online } from 'react-detect-offline';
import { Standard, NoInternet } from './components';

export default function Crash({ error }) {

  const [offline, setOffline] = useState();

  return (
    <>
      <Online>
        <Standard offline={offline}/>
      </Online>
      <Offline>
        <NoInternet set={setOffline}/>
      </Offline>
    </>
  );
}
